<template>
<el-dialog
  :visible='true'
  title='发送确认'
  :before-close='handleClose'
  width='650px'
  :close-on-click-modal='false'
>
<div style="line-height: 30px;">
  <div>
    <span >
      发送人数：
      <span :style="{ color: globalBG }">{{mediaTestMobilesList.length}}</span>人</span>
  </div>
  <div>
    富信内容：{{ formData.mediaTitle }}
  </div>
  <div>
    富信大小：<span :style="{ color: globalBG }">{{formData.totalSize}}M</span>
  </div>
  <div>
    富信计费条数：<span :style="{ color: globalBG }">1</span>条
  </div>
  <div>
    提交条数：<span :style="{ color: globalBG }">{{ mediaTestMobilesList.length }}</span>条
  </div>
</div>
<template #footer>
  <div class='dialog-bottom' >
    <el-button @click='handleClose' type='secondary' size='small'>取消</el-button>
    <el-button @click='handleConfirm' type='primary' size='small'>确定</el-button>
  </div>
</template>
</el-dialog>
</template>

<script>
import { getSmsMediaTemplateDetail } from "@/api/smsTemplates";
import {
  testMedia
} from "@/api/smsSend";
export default {
 name: '' ,
 components: {},
 props:{
  
  id:{
    type: String | Number,
    default: "",
  },
  mediaTestMobilesList:{
    default: [],
  },
  source:{
    default: "",
  },
  mediaTemplateId:{
    type: String | Number,
    default: "",
  }

 },
 data() {
  return {
    loading:false,
    globalBG:"#FE4D45",
    formData:{
      mediaTitle:'',
      totalSize:'',
    }
  }
 },
 computed: {},
 created() {
 
 },
 mounted() {
  this.loading = true;
    getSmsMediaTemplateDetail(this.id).then(res=>{
      if(res.code == 1){
        this.loading = false;
        // this.$nextTick(()=>{
          this.formData.mediaTitle = res.data.name;
          this.formData.totalSize = res.data.totalSize;
          console.log('this.formData',this.formData)
        // })
        // this.$emit('close');
      }else{
        this.$message.error(res.message);
      }
    })
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  handleConfirm() {
    testMedia({
      mediaTemplateId:this.mediaTemplateId,
      mediaTestMobiles:this.mediaTestMobilesList.join(','),
      source:this.source
    }).then(res=>{
      if(res.code == 1){
        this.$emit('confirm');
        this.$message.success('已提交发送！');
      }else{
        this.$message.error(res.message);
      }
    })
  },
  
 }
}
</script>
<style lang='scss' scoped>

.dialog-bottom {
  text-align: right;
}
</style>